import React from 'react'; 
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {Panel, FormGroup, FormControl} from 'react-bootstrap'; 
import BmcBlockIcon from '../common_components/bmc/BmcBlockIcon';
import {BMC_BLOCKS, BMC_STAGES} from '../common_components/bmc/bmc_constants';
import CardsList from './CardsList';
import BlockActions from '../bmc_components/BlockActions';
import BlockModal from '../bmc_components/BlockModal';
import {BOARD_TYPES} from './constants';




@injectIntl @inject("rootStore") @observer
class BmcBlock extends React.Component{

  constructor(props){
    super(props);
    this.handleBoardChange = this.handleBoardChange.bind(this);
    this.handleStageChange = this.handleStageChange.bind(this);
  }

  render(){
    const {block, intl} = this.props;
    let cards = [];
    const blockStore = this.props.rootStore.currentBlockStore;
    if( this.props.onlySelectedCards ){
      cards = this.props.rootStore.activityStore.activityEdit.getSelectedCardsByBlock(block);
    }
    else{
      cards = this.props.rootStore.igBusinessStore.getCurrentBoardCardsByBlock(this.props.block);
    }
    return(
      <div>

        <FormGroup controlId="formControlsSelect">
          <FormControl componentClass="select" placeholder="select"
            value={this.props.rootStore.igBusinessStore.currentBoard} onChange={this.handleBoardChange}>
            <option value={BOARD_TYPES.CURRENT_BMC}>{intl.formatMessage({id: "current_bmc"})}</option>
            <option value={BOARD_TYPES.VISION}>{intl.formatMessage({id: "vision_bmc"})}</option>
          </FormControl>
        </FormGroup>

        <Panel className="border-top-6 border-top">
          <BmcBlockIcon block={block} />&nbsp; 
          <span className="bold block-name">{intl.formatMessage({id: "IgbmcBoard-"+block})}</span>
          <br /><br />
          <BlockActions blockStore={blockStore}/>                    
          <BlockModal blockStore={blockStore}/>
          <CardsList
            cards={cards}
            onSelect={this.props.onCardSelection}
            />
        </Panel>  

      </div>
    );
  }

  handleBoardChange(e){
    const type = e.target.value;
    this.props.rootStore.igBusinessStore.setCurrentBoard(type); 
  }

  handleStageChange(e){
    this.props.rootStore.igBusinessStore.setCurrentStage(e.target.value); 
  }

}

export default injectIntl(BmcBlock);